export const baseUrl = '/reports'
